export default "__VITE_ASSET__c25e6168__"